module.exports = __webpack_public_path__ + "static/media/03.db2a561c.png";